import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ErrorState = ({ 
  title = 'Something went wrong',
  message = 'An error occurred. Please try again.',
  action,
  actionText = 'Try Again'
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-6 text-center">
      <ExclamationTriangleIcon className="w-12 h-12 text-red-500 mb-4" />
      <h3 className="text-xl font-medium text-white mb-2">{title}</h3>
      <p className="text-gray-400 mb-6">{message}</p>
      {action && (
        <button
          onClick={action}
          className="px-4 py-2 bg-dark-hover text-gray-200 rounded-lg hover:bg-dark-hover/70 transition-colors"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default ErrorState; 